let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9o7xf")).then(() => parcelRequire('aLW4m'));